import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  closeProductModal,
  refreshProductList,
} from "../../../redux/features/productModalSlice";
import Select from "react-select";
import {
  StateList,
  CityList,
} from "../../../redux/services/ProductService/product.Services";
import { AddSupplier } from "../../../redux/services/SupplierService/supplier.Services";
import { successToast, errorToast } from "../../../Utils/toast";
function CreateSupplier({ refreshData }) {
  const dispatch = useDispatch();
  const [errors, setErrors] = useState({});
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    supplier_name: "",
    company_name: "",
    mobile_number: "",
    email: "",
    gst_number: "",
    address: "",
    city: "",
    state: "",
    pincode: "",
    status: 1,
  });
  const validate = () => {
    let newErrors = {};

    if (!formData.supplier_name) {
      newErrors.supplier_name = "Supplier name is required";
    }

    if (!formData.company_name) {
      newErrors.company_name = "Company is required";
    }
    if (!formData.mobile_number) {
      newErrors.mobile_number = "Mobile is required";
    }
    if (!formData.email) {
      newErrors.email = "Category is required";
    }
    if (!formData.gst_number) {
      newErrors.gst_number = "GST Number is required";
    }
    if (!formData.address) {
      newErrors.address = "Adders is required";
    }
    // if (!formData.city) {
    //   newErrors.city = "City is required";
    // }
    // if (!formData.state) {
    //   newErrors.state = "State is required";
    // }
    if (!formData.pincode) {
      newErrors.pincode = "Pin Code is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    getStates();
  }, []);

  const getStates = async () => {
    try {
      const res = await StateList();

      if (res.success) {
        setStates(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleStateChange = async (selectedOption) => {
    setSelectedState(selectedOption);
    setSelectedCity(null);

    setErrors((prev) => ({
      ...prev,
      state: "",
      city: "",
    }));

    try {
      const res = await CityList({
        state_id: selectedOption.value, // 👈 JSON me state key
      });

      if (res.success) {
        setCities(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleCityChange = (selectedOption) => {
    setSelectedCity(selectedOption);

    setErrors((prev) => ({
      ...prev,
      city: "",
    }));
  };
  // const handleChange = (e) => {
  //   const { name, value } = e.target;

  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }));

  //   setErrors((prev) => ({
  //     ...prev,
  //     [name]: "",
  //   }));
  // };
 const handleChange = async (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
      // State change hone par city reset kar do
      ...(name === "state" ? { city: "" } : {}),
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    // Agar State change hui ho to City fetch karo
    if (name === "state") {
      const found = states.find((s) => s.name === value);
      if (found) {
        try {
          const res = await CityList({ state_id: found.id });
          if (res.success) {
            setCities(res.data);
          }
        } catch (error) {
          console.log(error);
          setCities([]);
        }
      } else {
        setCities([]);
      }
    }
  };
 
 
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);

    try {
      const payload = {
        ...formData,
        state: selectedState?.label,
        city: selectedCity?.label,
      };
      const res = await AddSupplier(payload);

      if (res.success) {
        successToast("Success", res.message);

        refreshData?.();

        dispatch(refreshProductList());

        dispatch(closeProductModal());
      }
    } catch (error) {
      if (error?.response?.status === 422) {
        setErrors(error.response.data.errors);
      } else {
        errorToast("Error", "Something went wrong");
      }
    }
    finally {
      setLoading(false);
    }
  };
  return (





    <div className="main_page">
      <form onSubmit={handleSubmit} className="row g-2">
        <div className="col-md-6">
          <label>
            Supplier Name <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            name="supplier_name"
            value={formData.supplier_name}
            onChange={handleChange}
            className={`form-control ${errors.supplier_name ? "is-invalid" : ""
              }`}
          />

          {errors.supplier_name && (
            <div className="invalid-feedback">
              {Array.isArray(errors.supplier_name)
                ? errors.supplier_name[0]
                : errors.supplier_name}
            </div>
          )}
        </div>
        <div className="col-md-6">
          <label>Company Name <span className="text-danger">*</span></label>

          <input
            name="company_name"
            value={formData.company_name}
            onChange={handleChange}
            className={`form-control ${errors.company_name ? "is-invalid" : ""}`}
          />

          <div className="invalid-feedback">
            {errors.company_name}
          </div>

        </div>
        <div className="col-md-6">
          <label>Mobile Number <span className="text-danger">*</span></label>

          <input
            type="text"
            name="mobile_number"
            value={formData.mobile_number}
            maxLength={10}
            onChange={(e) => {
              handleChange({
                target: {
                  name: "mobile_number",
                  value: e.target.value.replace(/\D/g, "")
                }
              })
            }}
            className={`form-control ${errors.mobile_number ? "is-invalid" : ""}`}
          />

          <div className="invalid-feedback">
            {errors.mobile_number}
          </div>

        </div>
        <div className="col-md-6">
          <label>Email <span className="text-danger">*</span></label>

          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className={`form-control ${errors.email ? "is-invalid" : ""}`}
          />

          <div className="invalid-feedback">
            {errors.email}
          </div>

        </div>

        <div className="col-md-6">
          <label>
            Enter GST <span className="text-danger">*</span>
          </label>

          <input
            type="text"
            name="gst_number"
            value={formData.gst_number}
            style={{ textTransform: "uppercase" }}
            className={`form-control ${errors.gst_number ? "is-invalid" : ""}`}
            onChange={(e) => {
              setFormData((prev) => ({
                ...prev,
                gst_number: e.target.value.toUpperCase(),
              }));

              setErrors((prev) => ({
                ...prev,
                gst_number: "",
              }));
            }}
          />

          {errors.gst_number && (
            <div className="invalid-feedback">
              {Array.isArray(errors.gst_number)
                ? errors.gst_number[0]
                : errors.gst_number}
            </div>
          )}
        </div>

{/*         
        <div className="col-md-6">
          <label>
            State <span className="text-danger">*</span>
          </label>

          <Select
            options={states.map((item) => ({
              value: item.id,
              label: item.name,
            }))}
            value={selectedState}
            onChange={handleStateChange}
            placeholder="Search State..."
            isSearchable
          />
          {errors.state && (
            <small className="text-danger">{errors.state}</small>
          )}
        </div>
        <div className="col-md-6">
          <label>
            City <span className="text-danger">*</span>
          </label>
          <Select
            options={cities.map((item) => ({
              value: item.id,
              label: item.name,
            }))}
            value={selectedCity}
            onChange={handleCityChange}
            placeholder="Search City..."
            isSearchable
          />

          {errors.city && (
            <small className="text-danger">{errors.city}</small>
          )}
        </div> */}

<div className="col-md-6">
          <label>
            State <span className="text-danger">*</span>
          </label>
          <select
            name="state"
            value={formData.state}
            onChange={handleChange}
            className={`form-control custumform ${
              errors?.state ? "is-invalid" : ""
            }`}
          >
            <option value="">Select State</option>
            {states.map((item) => (
              <option key={item.id} value={item.name}>
                {item.name}
              </option>
            ))}
          </select>
          {errors.state && (
            <div className="invalid-feedback d-block">
              {Array.isArray(errors.state) ? errors.state[0] : errors.state}
            </div>
          )}
        </div>

        {/* CITY — Native Select */}
        <div className="col-md-6">
          <label>
            City <span className="text-danger">*</span>
          </label>
          <select
            name="city"
            value={formData.city}
            onChange={handleChange}
            className={`form-control custumform ${
              errors?.city ? "is-invalid" : ""
            }`}
            disabled={!formData.state}
          >
            <option value="">Select City</option>
            {cities.map((item) => (
              <option key={item.id} value={item.name}>
                {item.name}
              </option>
            ))}
          </select>
          {errors.city && (
            <div className="invalid-feedback d-block">
              {Array.isArray(errors.city) ? errors.city[0] : errors.city}
            </div>
          )}
        </div>

        <div className="col-md-6">
          <label>Pin Code <span className="text-danger">*</span></label>

          <input
            type="text"
            name="pincode"
            placeholder="Enter PinCode"
            value={formData.pincode}
            onChange={handleChange}
            maxLength={6}
            className={`form-control ${errors.pincode ? "is-invalid" : ""}`}
          />

          <div className="invalid-feedback">
            {errors.pincode}
          </div>

        </div>
        <div className="col-12">

          <label>
            Address <span className="text-danger">*</span>
          </label>

          <textarea
            rows="3"
            name="address"
            placeholder="Enter Adderss"
            value={formData.address}
            onChange={handleChange}
            className={`form-control ${errors.address ? "is-invalid" : ""}`}
          />

          <div className="invalid-feedback">
            {errors.address}
          </div>

        </div>


        <button
          type="submit"
          className="btn btn-primary w-100"
          disabled={loading}
        >
          {loading ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Creating...
            </>
          ) : (
            "Create Supplier"
          )}
        </button>
      </form>
    </div>
  );
}

export default CreateSupplier;